const initialState = {
	loading: false,
	most_viewed: [],
	error: ""
}

const mostViewedReducer = (state= initialState, action) => {
	switch(action.type) {
		case "FETCH_MOSTVIEWED_REQUEST":
			return {...state, loading: true}
		case "FETCH_MOSTVIEWED_SUCCESS":	
			return {most_viewed: action.payload, loading: false}
		case "FETCH_MOSTVIEWED_FAILURE":	
			return {most_viewed: [], loading: false,error: action.payload}
		default:
			return state
	}
}
export default mostViewedReducer